import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Groomers.css";
import RegistrationModal2 from "../../components/RegistrationModal2";

const Groomers = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Keep your pet looking and feeling their best</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Groomers
                    </h1>
                    <p className="font-semibold">
                      Keep your pet looking and feeling their best with our professional grooming services. From baths and haircuts to nail trimming and styling, we cover all your pet's grooming needs.
                    </p>
                    <p>
                      Our experienced groomers use pet-friendly products and gentle techniques to ensure a stress-free experience for your furry friend.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-50 mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal2">
                      Join Us Now
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                      className="w-100"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/services_icon/groomers.png`}
                      alt="Groomers"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Registration Modal 2 for Service Providers */}
        <RegistrationModal2 preSelectedService="grooming" />
      </section>
    </>
  );
};

export default Groomers;
